const STATISTICS_CATEGORY_VARIANT_MARKER = '::variant::'

/**
 * Keep pest selections attached to their stable category when the backend
 * changes between a single key and project-specific variant dimensions.
 * Exact values win; a stale variant (or stable key) then expands to every
 * currently available dimension with the same stable prefix.
 */
export const reconcilePestTypeSelections = (
    selectedValues: readonly string[],
    availableOptions: readonly { value: string }[]
): string[] => {
    const availableValues = availableOptions
        .map((option) => option.value)
        .filter((value) => value.trim().length > 0)
    const availableSet = new Set(availableValues)
    const valuesByStableIdentity = new Map<string, string[]>()

    for (const value of availableValues) {
        const stableIdentity = value.split(STATISTICS_CATEGORY_VARIANT_MARKER, 1)[0]
        if (!stableIdentity) {
            continue
        }
        const values = valuesByStableIdentity.get(stableIdentity) ?? []
        values.push(value)
        valuesByStableIdentity.set(stableIdentity, values)
    }

    const reconciled: string[] = []
    const seenValues = new Set<string>()
    const append = (value: string) => {
        if (!seenValues.has(value) && availableSet.has(value)) {
            seenValues.add(value)
            reconciled.push(value)
        }
    }

    for (const selectedValue of selectedValues) {
        if (availableSet.has(selectedValue)) {
            append(selectedValue)
            continue
        }

        const stableIdentity = selectedValue.split(
            STATISTICS_CATEGORY_VARIANT_MARKER,
            1
        )[0]
        for (const value of valuesByStableIdentity.get(stableIdentity) ?? []) {
            append(value)
        }
    }

    return reconciled
}
